<template lang="pug">
    .election-component-title(:election-component-title-layout="layout")&attributes(customAttributes || {})&attributes(trackingAttributes || {})
        .election-component-title_element(v-if="isLive")
            LiveBullet.election-component-title_bullet-icon

        h2.election-component-title_element
            a.election-component-title_link(v-if="link" :href="link")&attributes(trackingAttributes || {})
                span.election-component-title_text {{ title }}
                IconArrowRight.election-component-title_icon
            span.election-component-title_text(v-else, :title="title") {{ title }}

        .election-component-title_element(v-if="fineprint")
            .election-component-title_count
                span.election-component-title_count_text {{ fineprint }}
</template>

<script>
import IconArrowRight from '../../assets/icon-chevron-right.svg';
import LiveBullet from '../LiveBullet/LiveBullet.vue';

export default {
  name: 'GroupTitle',
  props: {
    title: {
      type: String,
    },
    layout: {
      type: String,
      default: 'center'
    },
    fineprint: {
      type: String
    },
    link: {
      type: String,
    },
    isLive: {
      type: Boolean
    }
  },
  components: { LiveBullet, IconArrowRight }
};
</script>

<style lang="scss">
    @import "src/core/scss/global-sass";

	$o-hover: .7;

	$c-election-component-title-font: currentColor !default;
	$c-election-component-title-count-bg: #ededed !default;
	$c-election-component-title-count-font: #797979 !default;
	$c-election-component-title-subtitle-font: #9b9b9b !default;

	.election-component-title{
		& { padding: $m_spacing 0; color:$c-election-component-title-font;display: flex;align-items: center; margin-bottom: var(--spacing-unit); }
		&_text{
            @include font-title-l; line-height: 100%; display: block; color: var(--color-title);

            @include MQ_WideOnly() {
                @include font-title-xl;
            }

            @include MQ_MobileOnly() {
                font-size: calc(16px + 0.1rem);
            }
            @include thaustalianFonts();
        }

        & &_element {
            margin:0; padding:0;
        }

		// layout
		&[election-component-title-layout="center"] {
            justify-content: center;
        }

        &[election-component-title-layout="right"] {
            justify-content: flex-end;
        }


		// Live
		&_bullet-icon {margin-right: $m-spacing; display: block;margin-top: -2px;}


		// Link
		&_link{color:$c-election-component-title-font;text-decoration:none;text-transform: uppercase;display: flex;align-items: center;transition: all .3s ease-out;}
		&_link &_text{padding-right: $m-spacing*2;}
		&_link .election-component-title_icon{transition: transform 0.3s;transform: translateX(0);margin-top: -5px;height:23px;}
		&_link .election-component-title_icon path{fill:$c-election-component-title-font}
		&_link:hover {opacity: $o-hover;}
		@include MQ_MediumAndUp{
			&_link:hover .election-component-title_icon {transform: translateX($m-spacing);}
		}


		// Tags
		&_tag_wrapper { align-items: center; display: flex; }
		&_tag{ display: flex; color: $c-election-component-title-subtitle-font; border-left: 2px solid $c-election-component-title-subtitle-font; margin-left: $m-spacing*2; padding-left: $m-spacing*2; }
		&_tag_text{ @include font-base-m; color: $c-election-component-title-subtitle-font; }


		// Count
		&_count_wrapper{ align-items: center; display: flex; }
		&_count { display: flex; margin-left: $m-spacing; background-color: $c-election-component-title-count-bg; border-radius: 10px; padding: 4px $m-spacing 3px;  margin-top: -1px;}
		&_count--hidden { display: none; }
		&_count--no-badge { background: white; }
		&_count_text { color: $c-election-component-title-count-font; @include font-base-xs; }

		/* Icons
		---------------------------------------*/

        &[election-component-title-no-side-padding="true"]{padding:6px 0;}


        .eui-live-bullet {
            width: 24px;
            height: 24px;
        }
	}

</style>
